import React, { useState, useEffect } from 'react';
import { CheckCircle } from 'iconoir-react';

function SuccessToast({ show, message, onHide, duration = 3000 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(() => onHide(), 300); // Aguarda animação terminar
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [show, duration, onHide]);

  if (!show) return null;

  return (
    <div 
      className={`position-fixed top-0 start-50 translate-middle-x mt-3 ${visible ? 'animate__animated animate__fadeInDown' : 'animate__animated animate__fadeOutUp'}`}
      style={{
        zIndex: 9999,
        minWidth: '300px',
        maxWidth: '90vw'
      }}
    >
      <div 
        className="d-flex align-items-center p-3 text-white rounded-3 shadow-lg"
        style={{
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          border: '1px solid rgba(255,255,255,0.2)'
        }}
      >
        <CheckCircle 
          className="me-3" 
          style={{ 
            width: '24px', 
            height: '24px',
            color: '#ffffff'
          }} 
        />
        <div className="flex-grow-1">
          <div className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>
            Sucesso!
          </div>
          <div style={{ fontSize: '0.85rem', opacity: 0.9 }}>
            {message}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessToast;